import { Component, effect, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { LoadTranslationService } from '@zen/core/services/load-translation.service';
import { AuthService } from './studio-tools/services/auth-service';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {

  title = 'ZenBasket Builder';
  token: string = '';
  authloader = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  /**
   * Initializes a new instance of the class.
   * @param translateService Service providing various translate functionalities.
   */
  constructor(
    private translateService: LoadTranslationService,
    private route: ActivatedRoute
    
  ) {
    effect(() => {
      if (isPlatformBrowser(this.platformId)) {                // ← wrap document access
        if (this.authloader.authenticationLoader()) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      }
    });
    this.route.queryParamMap.subscribe(params => {
      const lang = params.get('lang') ?? 'en';
      this.translateService.loadTranslationFile(lang);
    });
    if (isPlatformBrowser(this.platformId)) {                  // ← wrap sessionStorage
      sessionStorage.clear();
    }
  }
}
